import React from "react";
import { Check } from "lucide-react";
import { STATUS_FLOW, statusLabel } from "@/lib/status";
import { useLang } from "@/context/LangContext";

export const OrderTimeline = ({ status }) => {
  const { t } = useLang();
  const currentIdx = STATUS_FLOW.indexOf(status);
  return (
    <div className="space-y-0" data-testid="order-timeline">
      {STATUS_FLOW.map((s, i) => {
        const done = i <= currentIdx;
        const active = i === currentIdx;
        return (
          <div key={s} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div className={`w-7 h-7 rounded-full grid place-items-center border-2 transition-colors ${done ? "bg-emerald-800 border-emerald-800 text-white" : "bg-white border-stone-300 text-stone-300"}`}>
                {done ? <Check className="w-4 h-4" /> : <span className="w-2 h-2 rounded-full bg-stone-300" />}
              </div>
              {i < STATUS_FLOW.length - 1 && <div className={`w-0.5 h-8 ${i < currentIdx ? "bg-emerald-800" : "bg-stone-200"}`} />}
            </div>
            <div className={`pt-1 text-sm ${active ? "font-semibold text-emerald-800" : done ? "text-stone-700" : "text-stone-400"}`}>
              {statusLabel(t, s)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
